import { useContext } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { AuthContext } from '@/auth/auth.context';
import { getTenantName } from '@/utils';
export const useShowAuthenticatedView = () => {
    const { isTokenPermissionsEmpty, isAppLoading } = useContext(AuthContext);
    const { isAuthenticated } = useAuth0();
    const tenantName = getTenantName();
    // ensure authenticatedView is not shown when we are authenticated by Auth0 but do not have permissions in the token
    // or when we are authenticated by Auth0 but do not have a tenant name
    const showAuthenticatedView = isAuthenticated && tenantName && !isTokenPermissionsEmpty;
    return {
        showAuthenticatedView,
        isLoading: isAppLoading,
    };
};
